import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var SkeletonTooltipController =
/*#__PURE__*/
function () {
  function SkeletonTooltipController() {
    _classCallCheck(this, SkeletonTooltipController);
  }

  _createClass(SkeletonTooltipController, [{
    key: "draw",
    value: function draw() {}
  }, {
    key: "drawAt",
    value: function drawAt() {}
  }, {
    key: "hide",
    value: function hide() {}
  }, {
    key: "hideAll",
    value: function hideAll() {}
  }, {
    key: "enableToolTip",
    value: function enableToolTip() {}
  }, {
    key: "disableToolTip",
    value: function disableToolTip() {}
  }, {
    key: "setStyle",
    value: function setStyle() {}
  }]);

  return SkeletonTooltipController;
}();

export default {
  extension: SkeletonTooltipController,
  name: 'ToolTipController',
  type: 'plugin'
};